import 'isomorphic-fetch'

import { videoContentEndpoint } from '~apiConfig'
import { getApiResponseInJSON, getIdToken } from '~utils'

import {
  ADD_VIDEO_CONTENT,
  FETCH_VIDEO_CONTENT_BY_ID,
  FETCH_VIDEO_CONTENTS,
  REMOVE_VIDEO_CONTENT,
  UPDATE_VIDEO_CONTENT,
  VIDEO_CONTENT_ACTION_STATUS
} from '../actionTypes'

export const fetchVideoContentList = params => async dispatch => {
  const { method, url } = videoContentEndpoint.list
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    body: JSON.stringify(params),
    headers: {
      Authorization: `Bearer ${idToken}`
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))
  const { videoContent: rows = [], videoContentCount: rowsCount = 0 } = apiResponse || {}
  dispatch({
    type: FETCH_VIDEO_CONTENTS,
    payload: { rows, rowsCount }
  })
}

export const fetchVideoContentById = id => async dispatch => {
  try {
    const { method, url } = videoContentEndpoint.edit(id)
    const idToken = getIdToken()
    const apiResponse = await fetch(url, {
      headers: {
        Authorization: `Bearer ${idToken}`
      },
      method
    })
      .then(async response => await getApiResponseInJSON(response))
      .catch(error => console.error(error))
    dispatch({
      type: FETCH_VIDEO_CONTENT_BY_ID,
      payload: { ...apiResponse }
    })
  } catch (error) {
    console.error(error)
  }
}

export const addVideoContent = (videoContent, accessToken) => async dispatch => {
  try {
    const { method, url } = videoContentEndpoint.add
    const idToken = getIdToken()
    const response = await fetch(url, {
      body: JSON.stringify({ videoContent }),
      headers: {
        Authorization: `Bearer ${idToken}`,
        AccessToken: accessToken
      },
      method
    })
    const data = await getApiResponseInJSON(response)
    if (data.success === false) {
      dispatch({
        type: ADD_VIDEO_CONTENT,
        payload: {
          message: data.message || 'Error adding video content',
          success: false
        }
      })
      return
    }
    const { addedVideoContent, message, success } = data
    dispatch({
      type: ADD_VIDEO_CONTENT,
      payload: {
        newVideoContentId: addedVideoContent?._id,
        message,
        success
      }
    })
  } catch (error) {
    console.error(error)
    dispatch({
      type: ADD_VIDEO_CONTENT,
      payload: {
        message: error.message || 'Error adding video content',
        success: false
      }
    })
  }
}

export const updateVideoContent = (id, videoContent, accessToken) => async dispatch => {
  try {
    const { method, url } = videoContentEndpoint.update(id)
    const idToken = getIdToken()
    await fetch(url, {
      body: JSON.stringify({ videoContent }),
      headers: {
        Authorization: `Bearer ${idToken}`,
        AccessToken: accessToken
      },
      method
    })
      .then(async response => await getApiResponseInJSON(response))
      .then(response => {
        const { message, success } = response
        dispatch({
          type: UPDATE_VIDEO_CONTENT,
          payload: { message, success }
        })
      })
      .catch(error => {
        console.error(error)
      })
  } catch (error) {
    console.error(error)
  }
}

export const removeVideoContent = (id, accessToken) => async dispatch => {
  const { method, url } = videoContentEndpoint.delete(id)
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    method,
    headers: {
      Authorization: `Bearer ${idToken}`,
      AccessToken: accessToken
    }
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => ({
      message: error.message,
      success: false
    }))
  const { deletedVideoContent } = apiResponse || {}
  const { acknowledged } = deletedVideoContent || {}
  dispatch({
    type: REMOVE_VIDEO_CONTENT,
    payload: {
      deleteMessage: acknowledged ? 'Video content deleted successfully' : 'Error while deleting video content',
      deleteStatus: !!acknowledged
    }
  })
}

export const resetVideoContentActionStatus = () => async dispatch => {
  dispatch({
    type: VIDEO_CONTENT_ACTION_STATUS,
    payload: {
      message: '',
      success: false,
      deleteMessage: '',
      deleteStatus: false
    }
  })
}
